import React, { useState } from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Expander from '@amzn/meridian/expander';
import Text from '@amzn/meridian/text';
import { useBundle } from '@amzn/react-arb-tools';
import { t } from 'src/helpers';
import { useIsMobileView } from 'src/components/Responsive/WindowDimensions';
import { HOMEPAGE_MESSAGE_BUNDLE_NAME } from 'src/utils/Constants';

const SwishipDescriptionExpander = () => {
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);
  const isMobile = useIsMobileView();
  const [expanderOpen, setExpanderOpen] = useState(true);
  
  return (
    <Box spacingInset="400">
      <Column heights={'fit'} alignmentVertical="top" alignmentHorizontal='center'>
        <Row width={isMobile ? undefined : '850px'} spacing='none' spacingInset='none' widths="fill">
          <Expander 
            open={expanderOpen}
            onChange={setExpanderOpen}
            title={t(bundle, 'swiship_what_is_swiship')}
            type="box"
          >
            <Text type="b300">
              {t(bundle, 'swiship_description')}
            </Text>
          </Expander>
        </Row>
      </Column>
    </Box>
  );
};

export default SwishipDescriptionExpander;
